/* jshint esversion: 6 */

import {EncryptionModifier} from "encryption/EncryptionModifier";

const DEFAULT_CRYPT_TOKEN = EncryptionModifier.getDefaultCryptToken(),
    CODE_OR_VAL = EncryptionModifier.getCodeOrVal();

export function encryptData( data, cryptToken = DEFAULT_CRYPT_TOKEN, useLegacyEncoder = true ) {

    if (typeof data !== "string") {
        return "";
    }

    return encrypt(data, cryptToken, useLegacyEncoder );
}

function encrypt( data, cryptToken, useLegacyEncoder ) {
    let encrypted = shiftLetters(data);
    encrypted = useLegacyEncoder ? escape( encrypted ) : encodeURI( encrypted );
    encrypted = replaceSpecialChars(encrypted);
    encrypted = reorganizeCharBase(encrypted);
    return markEncrypted( encrypted, cryptToken );
}

function shiftLetters(data) {
    let shiftedData = "";
    for (let i = 0; i < data.length; i++) {
        shiftedData += String.fromCharCode(data.charCodeAt(i) ^ CODE_OR_VAL);
    }
    return shiftedData;
}

function replaceSpecialChars(data) {
    return data.replace(new RegExp("%", "g"), "");
}

function reorganizeCharBase(data) {
    let encrypted = data;
    const hexMap = EncryptionModifier.getHexMap();
    hexMap.forEach((value, key) => {
        encrypted = encrypted.replace(new RegExp(key, "g"), value);
    });
    return encrypted;
}

function markEncrypted( data, cryptToken ) {
    return String.fromCharCode(cryptToken) + data;
}
